import { TGetItemFn, TStripeFormConfig } from '@/config/types'
import { PaymentMethodService } from '@/enums/paymentMethodServices'
import { PaymentMethod as PaymentMethodEnum } from '@/enums/payments'
import { PaymentScreenVersion } from '@/enums/paymentScreenVersion'

import { ApplePay2 } from '@/shared/icons/ApplePay2'
import { GooglePay2 } from '@/shared/icons/GooglePay2'
import { PayPalFull } from '@/shared/icons/PayPalFull'

import { PaymentMethod, selectPaymentMethodFunc } from './subComponents'
import { PaymentMethodIcons } from '../paymentMethodIcons'

type TPaymentMethodSwitcherProps = {
  currentPaymentMethod: PaymentMethodEnum | undefined
  onChange: selectPaymentMethodFunc
  showPayPal: boolean
  showStripe: boolean
  paymentMethodSwitcher?: TStripeFormConfig
  getItem: TGetItemFn
  walletType: PaymentMethodEnum | undefined
  paymentScreenVersion: PaymentScreenVersion
}

const defaultOrder: PaymentMethodService[] = [
  PaymentMethodService.VISA,
  PaymentMethodService.AMERICAN_EXPRESS,
  PaymentMethodService.DISCOVER,
  PaymentMethodService.MASTERCARD,
]

export const PaymentMethodToggle = ({
  currentPaymentMethod,
  onChange,
  showPayPal,
  showStripe,
  paymentMethodSwitcher,
  walletType,
  paymentScreenVersion,
}: TPaymentMethodSwitcherProps) => {
  const isPayPalSelected = currentPaymentMethod === PaymentMethodEnum.PAYPAL
  const isCreditCardSelected = currentPaymentMethod === PaymentMethodEnum.CARD
  const isWalletButtonSelected =
    currentPaymentMethod === PaymentMethodEnum.APPLE_PAY ||
    currentPaymentMethod === PaymentMethodEnum.GOOGLE_PAY

  const className = 'payment-method-switcher'

  return (
    <>
      <div className={className}>
        {showStripe && (
          <PaymentMethod
            isSelected={isCreditCardSelected}
            paymentType={PaymentMethodEnum.CARD}
            onClick={onChange}
          >
            <span>Credit card</span>
            <PaymentMethodIcons
              order={paymentMethodSwitcher?.paymentMethodSwitcherIcons?.order || defaultOrder}
            />
          </PaymentMethod>
        )}

        {walletType && (
          <PaymentMethod
            isSelected={isWalletButtonSelected}
            paymentType={walletType}
            onClick={onChange}
          >
            <div className="wallet-icons">
              {paymentScreenVersion === PaymentScreenVersion.v3_3 &&
                walletType === PaymentMethodEnum.APPLE_PAY && <span>Pay with</span>}
              {walletType === PaymentMethodEnum.APPLE_PAY && <ApplePay2 />}
              {walletType === PaymentMethodEnum.GOOGLE_PAY && <GooglePay2 />}
            </div>
          </PaymentMethod>
        )}

        {showPayPal && (
          <PaymentMethod
            isSelected={isPayPalSelected}
            paymentType={PaymentMethodEnum.PAYPAL}
            onClick={onChange}
          >
            <PayPalFull height={22} />
          </PaymentMethod>
        )}
      </div>
    </>
  )
}
